export enum TimeDisplay {
    TwelveHours = "am-pm",
    TwentyFourHours = "24hours",
}
